<div class="px-[74px]">
  <div class="mb-6 mt-6 max-w-[1400px]">
    <h2 class="font-bold text-[42px] leading-[50px] text-themeBlackTwo mb-3">Contributors</h2>
    <p class="font-medium text-base text-themeCharcoal">Diverse collection of talented illustrators, each
      bringing their own distinctive style!</p>
  </div>

  <ul class="flex text-base font-medium text-themeSuvaGrey leading-5 font-Inter space-x-6">
    <li class="cursor-pointer" (click)="setTab('AllAssets')"  [ngClass]="activeClass('AllAssets')">All Assets</li>
    <li class="cursor-pointer" (click)="setTab('3DIllustrations')" [ngClass]="activeClass('3DIllustrations')">3D
      Illustrations
    </li>
    <li class="cursor-pointer" (click)="setTab('LottieAnimations')" [ngClass]="activeClass('LottieAnimations')">
      Lottie Animations
    </li>
    <li class="cursor-pointer" (click)="setTab('Illustrations')" [ngClass]="activeClass('Illustrations')">
      Illustrations
    </li>
    <li class="cursor-pointer" (click)="setTab('IllustrationsKits')" [ngClass]="activeClass('IllustrationsKits')">
      Illustrations Kits
    </li>
    <li class="cursor-pointer" (click)="setTab('Icons')" [ngClass]="activeClass('Icons')">Icons</li>
  </ul>

  <div>
    <div [hidden]="activeTab !== 'AllAssets'">
      <div *ngFor="let contributor of [0, 1,]">
        <div class="border border-[#DFDEE1] p-[34px] rounded-2xl mt-6">

        <div class="flex items-center justify-start mb-8">
          <div class="h-24 w-24 rounded-full bg-[#F0F0F0] overflow-hidden">
            <img src="../../../../assets/theme/images/avatars/boy1.jpeg" class="w-full h-auto" alt="client">
          </div>
          <div class="flex flex-col items-start ms-[15px]">
            <h3 class="font-Inter text-[28px] font-bold text-[#1C2033]">Unicons Font</h3>
            <p class="text-base text-themeCharcoal font-bold flex justify-center items-center">icon
              designer and<span class="text-themeSuvaGrey mx-2 font-medium">2 more</span> with<span
                class="text-themeSuvaGrey ms-2 font-medium">7021 items</span></p>
          </div>
        </div>

        <div *ngFor="let contributor of contributors">
          <div class="grid grid-cols-4 gap-4">
            <div
              class="border border-themeWhisperTwo rounded-2xl text-center text-themeNeroThree p-7 font-Inter"
              *ngFor="let item of contributor.items.slice(0, 3);">
              <img [src]="item.img" class="w-full h-auto" alt="thumbnail">
            </div>

            <a href="{{contributor.link}}"
               class="border border-themeWhisperTwo rounded-2xl p-7 font-Inter text-black text-2xl flex justify-center items-center flex-col bg-[#F5F5F5]">

              <div
                class="border-[1.5px] border-[#D8DBEB] bg-white rounded-full h-[63px] w-[63px] flex justify-center items-center mb-5 ">
                <img src="../../../../assets/theme/images/icons/view-profile-icon.svg" alt="arrow">
              </div>

              View Profile
            </a>

          </div>
        </div>

      </div>
      </div>

    </div>
    <div [hidden]="activeTab !== '3DIllustrations'">
      <h2 class="font-bold text-[30px] leading-[50px] text-themeBlackTwo my-5">3D Illustrations Contributors</h2>

    </div>
    <div [hidden]="activeTab !== 'LottieAnimations'">
      <h2 class="font-bold text-[30px] leading-[50px] text-themeBlackTwo my-5">Lottie Animations Contributors</h2>
    </div>
    <div [hidden]="activeTab !== 'Illustrations'">
      <h2 class="font-bold text-[30px] leading-[50px] text-themeBlackTwo my-5">Illustrations Contributors</h2>
    </div>
    <div [hidden]="activeTab !== 'IllustrationsKits'">
      <h2 class="font-bold text-[30px] leading-[50px] text-themeBlackTwo my-5">Illustrations Kits Contributors</h2>
    </div>
    <div [hidden]="activeTab !== 'Icons'">
      <h2 class="font-bold text-[30px] leading-[50px] text-themeBlackTwo my-5">Icons Contributors</h2>
    </div>
  </div>




</div>
